import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgXIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 24.5C18.6274 24.5 24 19.1274 24 12.5C24 5.87258 18.6274 0.5 12 0.5C5.37258 0.5 0 5.87258 0 12.5C0 19.1274 5.37258 24.5 12 24.5ZM10.0607 8.43934C9.47487 7.85355 8.52513 7.85355 7.93934 8.43934C7.35355 9.02513 7.35355 9.97487 7.93934 10.5607L9.87868 12.5L7.93934 14.4393C7.35355 15.0251 7.35355 15.9749 7.93934 16.5607C8.52513 17.1464 9.47487 17.1464 10.0607 16.5607L12 14.6213L13.9393 16.5607C14.5251 17.1464 15.4749 17.1464 16.0607 16.5607C16.6464 15.9749 16.6464 15.0251 16.0607 14.4393L14.1213 12.5L16.0607 10.5607C16.6464 9.97487 16.6464 9.02513 16.0607 8.43934C15.4749 7.85355 14.5251 7.85355 13.9393 8.43934L12 10.3787L10.0607 8.43934Z",
		fill: "#D0021B"
	})]
});
const ForwardRef = forwardRef(SvgXIcon);
export { ForwardRef as ReactComponent };
